/* eslint-disable import/no-anonymous-default-export */

// import { defineConfig } from 'vite'
import { ETABLE } from './componentes/tabelas/ITabelas';
import { IPropsFilterObj } from './componentes/tabelas/TableFilter';
import {EICONS} from './servicos/EICONS';

// const APP_URL = import.meta.env.VITE_APP_URL;
// const AMBIENTE = import.meta.env.VITE_AMBIENTE;
const APP_URL = '';
const URL_APIG = import.meta.env.VITE_URL_APIG;

export interface IPropsNavigacao
{
    title: string,
    pathname: string|undefined,
    activeMenu: string[]|[],
    icon: EICONS,
    tipoPage: ETABLE,
    submenu: IPropsNavigacao[]
}

const AppConfig = {
	HTTP:
	{
		Timeout: 30 * 1000, // 
	},
	FIREBASE:{
		config:{
			apiKey: import.meta.env.VITE_APP_FIREBASE_APIKEY,
			authDomain: import.meta.env.VITE_APP_FIREBASE_AUTHDOMAIN,
			projectId: import.meta.env.VITE_APP_FIREBASE_PROJECTID,
			storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGEBUCKET,
			messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGINGSENDERID,
			appId: import.meta.env.VITE_APP_FIREBASE_APPID, 
			measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENTID 
		}
	},
	GCP:{
		config:{
			acervoBucketPadrao: import.meta.env.VITE_ACERVO_BUCKET_PADRAO
		}
	},
	API:
	{
		programas:
		{
			list: URL_APIG + '/entities/programa',
			create: URL_APIG + '/entities/programa',
			update: URL_APIG + '/entities/programa',
			delete: URL_APIG + '/entities/programa'
		},
		series:
		{
			list: URL_APIG + '/entities/serie',
			create: URL_APIG + '/entities/serie',
			update: URL_APIG + '/entities/serie',
			delete: URL_APIG + '/entities/serie'
		},
		anexos: {
			programa: URL_APIG + '/entities/anexo-programa',
			serie: URL_APIG + '/entities/anexo-serie',
			uploadUrl: URL_APIG + '/entities/anexo-upload-url',
		},
		produtora:
		{
			list: URL_APIG + '/entities/produtora',
			create: URL_APIG + '/entities/produtora',
			update: URL_APIG + '/entities/produtora',
			delete: URL_APIG + '/entities/produtora'
		},
		genero:
		{
			list: URL_APIG + '/entities/genero',
			create: URL_APIG + '/entities/genero',
			update: URL_APIG + '/entities/genero',
			delete: URL_APIG + '/entities/genero'
		},
		usuario:
		{
			list: URL_APIG + '/users/usuario',
			create: URL_APIG + '/users/usuario',
			update: URL_APIG + '/users/usuario',
			delete: URL_APIG + '/users/usuario',
			ExpiracaoUser: URL_APIG + '/exptoken'
		},
		repositorio:
		{
			list: URL_APIG + '/entities/repositorio',
			create: URL_APIG + '/entities/repositorio',
			update: URL_APIG + '/entities/repositorio',
			delete: URL_APIG + '/entities/repositorio'
		},
		util: {
			getUploadUrl: URL_APIG + '/entities/util',
		},		
	},
	URL: 
	{
		baseURL: APP_URL,
	},
	PATHS:
	{
		Login: 
		{
			Login: "/",
			Logout: "/logout",			
		},
		Dashboard:
		{
			home: '/home',
			ajuda: '/ajuda',
			programas:
			{
					lista: '/lista-programas',
					cadastro: '/cadastro-programas',
					editar: '/editar-programa'
			},
			series:
			{
					lista: '/lista-series',
					cadastro: '/cadastro-series',
					editar: '/editar-serie'
			},
			produtoras:
			{
					lista: '/lista-produtoras',
					cadastro: '/cadastro-produtoras',
			},
			idiomas:
			{
					lista: '/lista-idiomas',
					cadastro: '/cadastro-idiomas',
			},  



			genero:
			{
					lista: '/lista-generos',
					cadastro: '/cadastro-generos',
			},
			usuarios:
			{
					lista: '/lista-usuarios',
					cadastro: '/cadastro-usuario',
			},
			repositorio:
			{
					lista: '/lista-repositorio',
					cadastro: '/cadastro-repositorio',
			},
		}
	},
	NAVEGACAO: [
		{
			title: 'Programas',
			pathname: "lista-programas",
			activeMenu: ['lista-programas', 'home'],
			icon: EICONS.PROGRAMAS,
			tipoPage: ETABLE.PROGRAMAS,
			submenu: []
		},
		{
			title: 'Séries',
			pathname: "lista-series",
			activeMenu: ['lista-series'],
			icon: EICONS.SERIES,
			tipoPage: ETABLE.SERIES,
			submenu: []
		},
		{
			title: 'Produtoras',
			pathname: "lista-produtoras",
			activeMenu: ['lista-produtoras'],
			icon: EICONS.PRODUTORAS,
			tipoPage: ETABLE.PRODUTORA,
			submenu: []
		},
		{
			title: 'Gêneros',
			pathname: "lista-generos",
			activeMenu: ['lista-generos'],
			icon: EICONS.GENERO,
			tipoPage: ETABLE.GENERO,
			submenu: []
		},
		{
			title: 'Usuários',
			pathname: 'lista-usuarios',
			activeMenu: ['lista-usuarios'],
			icon: EICONS.USUARIOS,
			tipoPage: ETABLE.USER,
			submenu: []
		},
		{
			title: 'Configurações',
			pathname: undefined,
			activeMenu: [],
			icon: EICONS.CONFIGURACAOES,
			tipoPage: ETABLE.REPOSITORIO,
			submenu: [
					{
						title: 'Repositórios',
						pathname: 'lista-repositorio',
						activeMenu: ['lista-repositorio'],
						icon: EICONS.LIST,
						submenu: []
					},
			]
		},
		{
			title: 'Ajuda',
			pathname: 'ajuda',
			activeMenu: ['ajuda'],
			icon: EICONS.HOME,
			tipoPage: ETABLE.AJUDA,
			submenu: []
		}

	] as IPropsNavigacao[],
	Firebase: {
		StorageEmulator: import.meta.env.VITE_FIREBASE_STORAGE_EMULATOR === 'true',
		StorageEmulatorHost: import.meta.env.VITE_FIREBASE_STORAGE_EMULATOR_HOST || 'localhost:9199'
	}
};

export default AppConfig;

export const dateCoverter = (data:string) =>
{
	const date = new Date(data);

	const day = date.getUTCDate().toString().padStart(2, '0');
	const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
	const year = date.getUTCFullYear();

	return `${day}/${month}/${year}`;
}

export const replaceNullWithUndefined = (obj) =>
{
	for (const key in obj)
	{
		if (obj.hasOwnProperty(key))
		{
			if (obj[key] === null) {
				obj[key] = undefined;
			}
		}
	}
}

export const areAllValuesEmpty = (obj:IPropsFilterObj) =>
{
	return Object.values(obj).every(value => {
		return (
		value === null ||
		value === undefined ||
		(typeof value === "string" && value.trim() === "") ||
		(Array.isArray(value) && value.length === 0)
		);
	});
}  

export const filterSeriesOptions = (options: any[], { inputValue }: any) => {
	// Defina o número mínimo de caracteres exigidos
	const minChars = 2;
	if (inputValue.length < minChars) {
		// Retorna um array vazio para ocultar as opções quando o número mínimo de caracteres não for atingido
		return [];
	}
	// Filtra as opções com base no texto digitado
	return options.filter((option) =>
		option.titulo.toLowerCase().includes(inputValue.toLowerCase())
	);
};

export const converterFormatoData = (dataString:any) => {
	// Dividir a string em partes para obter dia, mês, ano e hora
	const partes = dataString.split(/[\/ :]/);

	// Criar uma nova instância de Date com as partes extraídas
	const novaData = new Date(
		partes[2],
		partes[1] - 1, // Mês é base 0 no objeto Date, então subtrai 1
		partes[0],
		partes[3] || 0, // Hora
		partes[4] || 0 // Minuto
	);

	// Formatando a nova data para o formato desejado
	const dataFormatada = novaData.toISOString();

	return dataFormatada;
}